import ls from '@/utils/Storage'
import { ACCESS_TOKEN, PERMISSION, USER_INFO, MENU_NAV } from '@/store/mutation-types'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import {createVNode} from 'vue'
import {Input,Modal} from 'ant-design-vue'
import { Indexable } from '#/global';

dayjs.extend(utc)
dayjs.extend(timezone)

export function clearUserInfo() {
  ls.remove(ACCESS_TOKEN)
  ls.remove(PERMISSION)
  ls.remove(USER_INFO)
  ls.remove(MENU_NAV)
}

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

// aes encryption key
export const encryptKeys = {
  // key最少4位,否则报错
  key: '1111',
  iv: '1',
};

export const getQueryParameters = (options) => {
  const url = options.url
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"') + '"}')
}

export const getBody = (options) => {
  return options.body && JSON.parse(options.body)
}

export function scorePassword(pass) {
  let score = 0
  if (!pass) {
    return score
  }
  // award every unique letter until 5 repetitions
  const letters = {}
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1
    score += 5.0 / letters[pass[i]]
  }

  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  }

  let variationCount = 0
  for (var check in variations) {
    variationCount += (variations[check] === true) ? 1 : 0
  }
  score += (variationCount - 1) * 10

  return score
}

export const firstLetterIsUpperCase = function (str) {
  var reg = /^[A-Z][A-z0-9]*$/;
  return reg.test(str);
};

export const separator = ';'

export const divisionStringToArray = (string, customSeparator) => {
  return string ? string.split(customSeparator || separator) : []
}

export const getWeek = (week: number, useZhou) => {
  let txt = ''
  switch (week) {
    case 1:
      txt = '一'
      break
    case 2:
      txt = '二'
      break
    case 3:
      txt = '三'
      break
    case 4:
      txt = '四'
      break
    case 5:
      txt = '五'
      break
    case 6:
      txt = '六'
      break
    case 0:
      txt = '日'
      break
    default:
      return 'getWeekError'
  }
  return useZhou ? '周' : '星期' + txt
}

const sitUrl = 'xxxxx'
export const isDev = import.meta.env.DEV
export const baseURL = import.meta.env.VITE_BASE_URL

export function toLocalTimeStr({ date, format = 'YYYY-MM-DD HH:mm:ss' }) {
  if (!date) return null;
  return dayjs(date).format(format)
}

export function objToArr(obj) {
  let arr: any = []
  for (const o in obj) {
    arr.push({ label: o, txt: obj[o] })
  }
  return arr
}

export function clearObj(obj) {
  for (const key in obj) {
    obj[key] = undefined
  }
}

export function delArrItem(arr, item) {
  const index = arr.indexOf(item);
  arr.splice(index, 1);
}

export const useImageUrl = (name: string, type: string = 'png'): string => {
  /**
   * @method vite动态引入图片
   * @params folder 文件夹名称 name 文件名称 type 文件格式 一般为png/jpg/webp/gif等...
   * @returns 图片
   */
  return new URL(`../assets/images/${name}.${type}`, import.meta.url).href
}

export const batchDispatch = (dispatch, arr) => {
  arr.forEach(item => {
    dispatch(item)
  });
}

export const createFormData = (formDatas, file) => {
  const formData = new FormData()
  if (file.length) {
    file.map(item => {
      formData.append('file', item)
    })
  } else {
    formData.append('file', file)
  }
  for (const item in formDatas) {
    formData.append(item, formDatas[item] || '')
  }
  return formData
}
//thumb 为TRUE时组装取缩略图
export const addip=(url:string,thumb:boolean=false)=>{
  if(!url){return ''}
  if(url.indexOf('http')>-1){
    return url
  }else if(url.indexOf('[')>-1&&url.indexOf(']')>-1){
    try{
      const urls:String[]=JSON.parse(url)

      if(urls.length>0){
        if(thumb){
          return thumbimg(baseURL+urls[0])
        }else{
          return baseURL+urls[0]
        }
      }else{
        return ''
      }
    }catch{
      return url
    }
  }else{
    if(thumb){
      return thumbimg(baseURL+url)
    }else{
      return baseURL+url
    }
  }
}
export const thumbimg=(url:string)=>{
  if(!url){return ''}
  const strs:String[]=url.split('/')
  const fname=strs.pop()
  strs.push('thumb_'+fname)
  return strs.join('/')
}


// 获取两个对象之间的差异不同
export function deepDiffKeys(obj1, obj2) {
  const diffKeys = []

  function deepCompare(o1, o2, key) {
    if (o1 === o2) return
    if (typeof o1 !== 'object' || o1 === null || typeof o2 !== 'object' || o2 === null) {
      diffKeys.push(key)
      return
    }

    for (const k in o1) {
      if (o2[k] === undefined) {
        diffKeys.push(key + '.' + k)
      } else {
        deepCompare(o1[k], o2[k], key + '.' + k)
      }
    }

    for (const k in o2) {
      if (o1[k] === undefined) {
        diffKeys.push(key + '.' + k)
      }
    }
  }

  deepCompare(obj1, obj2, 'root')
  return diffKeys
}
//弹出输入框
export const modalinput=({title,value,onOk})=>{
  let v=value||''
  const vnode=createVNode(Input,{placeholder: '请输入',type:'text',class:'margin-tb',value:v,onChange:e=> { v = e.target.value }},'')

      const m=Modal.confirm({
        title:title,
        icon:false,
        content:vnode ,
        onOk(){
          onOk(v)
          m.destroy()
        },
        onCancel(){
          m.destroy()
        }
      })
}
//自定义页面的样式
export const pagestyle=[{id:'dark',text:'暗色风格'},{id:'light',text:'亮色风格'}]
export const getCol={
  sm(col){return {span:24}},
  md(col){return {span:col>2?12:24}},
  lg(col){return {span:Math.abs(24/col)}}
}
export const colors=['#13c2c2','#e54d42','#f37b1d','#fbbd08','#8dc63f','39b54a','#1cbbb4','#0081ff','#6739b6','#9c26b0','#e03997','#a5673f','#8799a3','#aaaaaa','#343434']


export class DataModel{
  name:String='自定义';
  required:boolean=false;//是否必填
  domtype:String='input';
  //form中的类型 input|number|textarea|slider|date|datetime|radio|switch|select|mutiselect|cascader|checkbox|list|tags|keywords|keyvalue|img|imgs|video|file|editor
  value:any;
  desc:String='';
  data:Array=[];
  min:Number=0;
  max:Number=100000;
  map:Object={ name: 'name', value: 'value' };
  constructor(name:String) {
    this.name=name
  }
}

export const AutoData={

//从服务器取得的数据字段，组装为表格展示需要的数据
GetTableModel(m:Indexable<DataModel>,keys:Array<String>,action:Boolean=true){
    let d:Array=[]
    for(var key in m){
      if(keys.includes(key)){
           d.push({
            title: m[key].name,
            dataIndex: key,
            key:key,
            type:m[key].domtype,
            data:m[key].data
          })
      }
    }
    if(action){
      d.push({
      title: '操作',
      key: 'operation',
      fixed: 'right',
      width: 100,
    })
    }
    return d;
  },
//从服务器取得的数据字段，组装为编辑form需要的数据
GetFormModel(m:Indexable<DataModel>,keys:Array<String>){
    let d={}
    for (const [key, value] of Object.entries(m)) {
        if(keys.includes(key)){
            d[key]=value
        }
    }
    return d;
  },
//从服务器取得的数据字段，组装为查看detail需要的数据
GetDetailModel(m:Indexable<DataModel>,entity:Object,keys:Array<String>){
    let d={}
    for (const [key, value] of Object.entries(m)) {
        if(keys.includes(key)){
            d[key]=value
            if(entity.hasOwnProperty(key)){
              d[key].value=entity[key]
            }
        }
    }
    return d;
  },
  //组装默认数据
GetDefaltModel(m:Indexable<DataModel>,entity:Object){
    let d={}
    try{
      for (var [key, value] of Object.entries(m)) {
              if(entity==null||entity=={}){
                d[key]['ID']=0
              }
              if(entity.hasOwnProperty(key)){
                d[key]=entity[key]
              }else if(key=='ID'){
                d[key]=0
              }else if(value.value!=null&&value.value!=undefined){
                d[key]=value.value
              }else{
                d[key]=null
              }
      }
    }catch(ex){
      console.error('GetDefaltModel:ERROR',ex)
    }
    return d;
  },
  //m:从后台取得的每个字段的信息,
InitModel(m:Object){
    var d:Indexable<DataModel>={}
     for(var key in m){
      //有custom标识的，是用户自定义的数据，需要排除
      if(m[key].type!='custom'){
        d[key]=new DataModel(m[key].name)
        if(m[key].type=='number'){
          d[key].domtype='number'
        }else if(m[key].type=='datetime'){
          d[key].domtype='datetime'
        }else if(m[key].type=='bool'){
          d[key].domtype='switch'
        }else if((m[key].data&&m[key].data.length>0)||m[key].type=='enum'){
          d[key].domtype='select'
        }else{
          d[key]=m[key]
        }
        if(m[key].value){
          d[key].value=m[key].value
        }
        if(m[key].data){
          d[key].data=m[key].data
        }
        d[key].required=m[key].required
      }
     }
     return d;
  },
InitValue(m:Indexable,entity:Object,keys:Array=null){
  var d={}
    if(keys==null){
      for (var [key, value] of Object.entries(m)) {
               d[key]=value
              if(entity.hasOwnProperty(key)){
                d[key].value=entity[key]
              }
      }
    }else if(Array.isArray(keys)){
      keys.forEach(e => {
          if(m.hasOwnProperty(e)){
            d[e]=Object.assign({},m[e])
            if(entity.hasOwnProperty(e)){
              d[e].value=entity[e]
            }else{
              d[e].value=''
            }
          }
      });
    }

    return d;
},
  //从模型中找到data中的值序列，并返回与值对应的name
FindName(m:Indexable<DataModel>,key:String,value:Object){
    let name='-'
    if(m.hasOwnProperty(key)&&m[key].data){
      var n=m[key].data.find(e=>{return e.value==value})
      if(n){name=n.name}
    }
    return name;
  }
}
